export function PalmLogo({ className = "h-9 w-auto", light = false }) {
  return (
    <img
      src={light ? "/brand-icon.png" : "/brand-logo.png"}
      alt="Caribbean Drive"
      className={`${className} object-contain ${light ? "rounded-lg" : ""}`}
    />
  );
}

export function LogoFull({ light = false }) {
  return (
    <div className="flex items-center gap-2">
      <PalmLogo light={light} className="h-9 w-9" />
      <div className="leading-none">
        <span className={`font-heading font-extrabold text-lg tracking-tight ${light ? "text-white" : "text-canard-dark"}`}>
          CARIBBEAN
        </span>
        <span className="font-heading font-extrabold text-lg tracking-tight text-emeraude"> DRIVE</span>
      </div>
    </div>
  );
}
